import { useMemo } from 'react'
import { MapPinned } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { GeoRegistryTable } from './GeoRegistryTable'
import { GEO_STR as S, type GeoConfigRow } from './geoApi'

/**
 * A11.13 — IP gyo-baza. Admin IP-diapazon → davlat moslashuvlarini (source:
 * MaxMind/IP2Location/qo'lda) boshqaradi. JONLI CRUD: `/admin/geo/ip-ranges`.
 */
export function IpGeoBaseScreen() {
  const columns = useMemo<AdminColumn<GeoConfigRow>[]>(
    () => [
      {
        key: 'cidr',
        header: S.cidr,
        type: 'text',
        minWidth: 180,
        render: (r) => <span className="font-mono tabular text-primary">{String(r.cidr ?? '')}</span>,
      },
      { key: 'country_code', header: S.code, type: 'id', width: 90 },
      { key: 'source', header: S.sourceCol, type: 'text', minWidth: 160 },
      { key: 'created_at', header: S.createdCol, type: 'date', width: 150 },
    ],
    [],
  )

  return (
    <GeoRegistryTable
      screenId="A11.13"
      title={S.ipGeoTitle}
      description={S.ipGeoNote}
      addLabel={S.addIpRange}
      path="/admin/geo/ip-ranges"
      listKey="ranges"
      searchKeys={['cidr', 'country_code', 'source']}
      fields={[
        { name: 'cidr', placeholder: S.cidr, mono: true },
        { name: 'country_code', placeholder: S.code },
        { name: 'source', placeholder: S.sourceCol },
      ]}
      columns={columns}
      icon={<MapPinned size={28} strokeWidth={1.5} />}
    />
  )
}
